import { getRandomColor } from "@/helpers/helperFunctions";
import { NodeData, RawNode } from "./types";

export function migrateNodeData(nodeData: any) {
  if (!nodeData) return nodeData;

  // Rename `title` to `name` if applicable
  if ("title" in nodeData && !("name" in nodeData)) {
    nodeData["name"] = nodeData["title"];
  }

  // Convert `other_inputs` into structured `params` and `sources`
  if ("other_inputs" in nodeData && !("params" in nodeData)) {
    nodeData = {
      ...nodeData,
      // Mapping existing inputs/outputs
      inputs: nodeData?.inputs?.map((item: any, idx: number) => ({
        id: item?.id,
        name: nodeData?.inputs_list?.[idx],
      })),
      outputs: nodeData?.outputs?.map((item: any, idx: number) => ({
        id: item?.id,
        name: nodeData?.outputs_list?.[idx],
      })),
    };
  }
  return { ...nodeData, color: getRandomColor() };
}
export function transformNode(oldData: RawNode | NodeData) {
  if (
    "inputs_list" in oldData &&
    "inputs" in oldData &&
    "outputs" in oldData &&
    "outputs_list" in oldData &&
    "other_inputs" in oldData &&
    "title" in oldData &&
    "short_name" in oldData &&
    "category" in oldData &&
    "description" in oldData &&
    "type" in oldData &&
    "unique_key" in oldData &&
    "name" in oldData
  ) {
    return { ...oldData, color: getRandomColor() } as NodeData;
  }

  return {
    inputs_list: oldData?.inputs?.map?.((input, index) => `Input ${index + 1}`),
    inputs: oldData?.inputs?.map?.((_, index) => ({
      id: `input-port-${Math.random()}`,
      name: "input " + (index + 1),
    })),
    outputs: oldData?.outputs?.map?.((output) => ({
      id: `output-port-${Math.random()}`,
      name: output.name,
    })),
    outputs_list: oldData?.outputs?.map?.((output) => output.name),
    other_inputs: [
      ...(oldData?.params
        ?.map((param) => {
          if (param.box_type === "Text Box") {
            return {
              type: "input",
              min_value: param.min_value,
              max_value: param.max_value,
              default_value: param.default_value,
              name: param.name,
              input_type: param.type,
              value: param?.forced_value?.[param.name] || param.default_value,
            };
          } else if (param.box_type === "Dropdown") {
            return {
              type: "dropdown",
              min_value: param.min_value,
              max_value: param.max_value,
              name: param.name,
              options: param.values, // already an array
              input_type: param.type,
              value: param.values?.[0],
            };
          } else if (param.box_type === "Symbol selector") {
            return {
              type: "symbolSelector",
              min_value: param.min_value,
              max_value: param.max_value,
              default_value: param.default_value,
              name: param.name,
              input_type: param.type,
              value: param?.forced_value?.[param.name] || param.default_value,
            };
          }
          return null; // Optional fallback
        })
        .filter(Boolean) ?? []),

      ...(oldData?.sources?.map((source) => ({
        type: "dropdown",
        min_value: source.min_value,
        max_value: source.max_value,
        name: source.name,
        options: source.values,
        input_type: source.type,
        value: source?.values?.includes("Close")
          ? "Close"
          : source?.values?.[0],
      })) ?? []),
    ],
    title: oldData.name,
    short_name: oldData.short_name,
    category: oldData.category,
    description: oldData.description,
    type: oldData.type,
    unique_key: oldData.unique_key,
    id: oldData?.id,
    name: oldData.name,
    color: getRandomColor(),
  };
}
